export default __webpack_public_path__ + "static/media/Tolls.e5c14627.png";